<template>
    <Head title="Create Profile" />
    <BaseLayout gap="none" fill-height>
        <ProfileCreationFlow :creation="props" :auto-generate="autoGenerate" :share-back-target="props.share_back_target" />
    </BaseLayout>
</template>

<script lang="ts">
import LeftSidebarLayout from "~vue/layouts/LeftSidebarLayout.vue";
export default { layout: LeftSidebarLayout };
</script>

<script setup lang="ts">
import { Head } from "@inertiajs/vue3";
import { useUrlSearchParams } from "@vueuse/core";
import type { ShareBackTarget } from "~vue/CollaborationProfile/composables/useProfileShareBack";
import BaseLayout from "~vue/components/BaseLayout.vue";
import ProfileCreationFlow from "~vue/components/ProfileWizard/ProfileCreationFlow.vue";
import type { ProfileCreationProps } from "~vue/types/profile";

const props = defineProps<ProfileCreationProps & { share_back_target?: ShareBackTarget | null }>();
const searchParams = useUrlSearchParams("history");
const autoGenerate = searchParams.auto_generate === "true";
delete searchParams.auto_generate;
</script>
